import { render, staticRenderFns } from "./PlateUpdate.vue?vue&type=template&id=0582afda&scoped=true&"
import script from "./PlateUpdate.vue?vue&type=script&lang=js&"
export * from "./PlateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PlateUpdate.vue?vue&type=style&index=0&id=0582afda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582afda",
  null
  
)

export default component.exports